module.exports = __webpack_public_path__ + "media/Pandora-2.ac76fa8b.mp4";